var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { RequerimentoApi } from '../../../apis/requerimentoAPi';
import { TarefaApi } from '../../../apis/tarefa-api';
import { ShowContent } from '../../../components/ShowContent';
import { DefaultContent } from '../../../components/DefaultContent';
import { Typography } from '@mui/material';
import { BoxContainerLayout } from '../../../components/BoxContainerLayout';
import { TaxaContempladaList } from './TaxaContempladaList';
import { TaxasEmitidas } from './TaxasEmitidas';
import { HandleError } from '../../utils/HandleError';
import { StatusAndamento } from '../../../model/enums/StatusAndamento';
export var RequerimentoTaxa = function () {
    //region Constants
    var intervalRef = useRef(null);
    var _a = useState(undefined), requerimento = _a[0], setRequerimento = _a[1];
    var _b = useState(false), loadingRequerimento = _b[0], setLoadingRequerimento = _b[1];
    var _c = useState(null), tarefaAtual = _c[0], setTarefaAtual = _c[1];
    var _d = useState(false), loadingTarefa = _d[0], setLoadingTarefa = _d[1];
    var _e = useState(), error = _e[0], setError = _e[1];
    var id = useParams().id;
    //endregion
    //region Hooks
    useEffect(function () {
    }, []);
    useEffect(function () {
        if (id) {
            var _id = Number(id);
            if (!isNaN(_id)) {
                setLoadingTarefa(true);
                handleLoadRequerimento(_id);
                handleLoadTarefaAtual(_id);
            }
        }
    }, [id]);
    useEffect(function () {
        if (id && !tarefaAtual) {
            intervalRef.current = setInterval(function () {
                var _id = Number(id);
                if (!isNaN(_id)) {
                    handleLoadTarefaAtual(_id);
                }
                if (tarefaAtual && intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
            }, 10000);
        }
        return function () {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [id, tarefaAtual]);
    var aguardandoLiberacao = useMemo(function () {
        return (tarefaAtual === null || tarefaAtual === void 0 ? void 0 : tarefaAtual.userTaskId) === 'TaskId_autorizacao_gerar_taxa' && (tarefaAtual === null || tarefaAtual === void 0 ? void 0 : tarefaAtual.andamento) !== StatusAndamento.CONCLUIDO;
    }, [tarefaAtual === null || tarefaAtual === void 0 ? void 0 : tarefaAtual.userTaskId, tarefaAtual === null || tarefaAtual === void 0 ? void 0 : tarefaAtual.andamento]);
    //endregion
    //region Handles
    var handleLoadRequerimento = function (requerimentoId) {
        setLoadingRequerimento(true);
        RequerimentoApi.buscarPorId(requerimentoId)
            .then(function (req) { return setRequerimento(__assign({}, req)); })
            .catch(function (error) { return setError(error); })
            .finally(function () { return setLoadingRequerimento(false); });
    };
    var handleLoadTarefaAtual = function (requerimentoId) {
        setLoadingTarefa(true);
        TarefaApi.tarefaAtual(requerimentoId).then(function (tarefa) {
            setLoadingTarefa(false);
            setTarefaAtual(tarefa);
        }).catch(function (err) { return setError(err); });
    };
    //endregion
    return (_jsxs(BoxContainerLayout, { children: [_jsx(ShowContent, __assign({ show: (loadingTarefa || loadingRequerimento) }, { children: _jsx(Typography, __assign({ textAlign: 'center', variant: 'h5', marginTop: '150px', marginBottom: '50px' }, { children: "Carregando Informa\u00E7\u00F5es sobre o requerimento." })) })), _jsxs(DefaultContent, __assign({ loading: (loadingTarefa || loadingRequerimento) }, { children: [_jsx(ShowContent, __assign({ show: aguardandoLiberacao }, { children: _jsx(TaxaContempladaList, { requerimento: requerimento }) })), _jsx(ShowContent, __assign({ show: !aguardandoLiberacao }, { children: _jsx(TaxasEmitidas, {}) }))] })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] }));
};
